import objectUtil from "@/utils/objectUtil";

const getValueType = (value) => {
    if (objectUtil.isArray(value) && value.length > 0) {
        return `array[${getValueType(value[0])}]`;
    } else if (objectUtil.isObject(value) && Object.keys(value).length > 0) {
        return `object{${Object.keys(value).map(key => `${key}: ${getValueType(value[key])}`).join(', ')}}`
    } else if (typeof value === 'string') {
        return 'string';
    } else if (typeof value === 'function') {
        return 'function';
    } else if (typeof value === 'number') {
        if (Number.isInteger(value)) {
            return 'integer';
        } else {
            return 'float';
        }
    } else {
        return 'unknown';
    }
}

export default {
    getValueType
};
